import { SplineScene } from "../ui/splite";
import { Card } from "../ui/card";
import { Spotlight } from "../ui/spotlight";

/*
  FutureHero — pink reskin of the Spline "Interactive 3D" hero.
  ───────────────────────────────────────────────────────────────────────────
  Dropped in at the bottom of the storefront (just above the footer). The
  reference demo used a near-black card + white spotlight; this is retoned onto
  AB8's deep-cherry/pink palette: cherry card surface, a pink (`#ec4899`,
  tea-500) spotlight, and a bold "THE FUTURE IS HERE" wordmark in a pink
  gradient. The 3D robot scene lives on the right.
*/
export default function FutureHero() {
  return (
    <Card className="w-full h-[500px] bg-[#2e0810] relative overflow-hidden border-pink-900/40 rounded-none">
      <Spotlight
        className="-top-40 left-0 md:left-60 md:-top-20"
        fill="#ec4899"
      />

      <div className="flex h-full flex-col md:flex-row">
        {/* Left content */}
        <div className="flex-1 p-8 md:p-12 relative z-10 flex flex-col justify-center">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-pink-400/30 bg-pink-500/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-pink-200">
            AB8 Beauty · Next chapter
          </span>
          <h1 className="mt-5 text-5xl md:text-7xl font-black uppercase tracking-tight leading-[0.95] bg-clip-text text-transparent bg-gradient-to-b from-pink-100 via-pink-300 to-pink-500">
            The Future<br />Is Here
          </h1>
          <p className="mt-5 text-pink-100/70 max-w-lg text-base md:text-lg">
            Skincare that glows back. Explore immersive, interactive beauty
            rituals built to capture attention and elevate your shelf.
          </p>
        </div>

        {/* Right content — the 3D robot, tinted pink */}
        <div className="flex-1 relative min-h-[260px]">
          <SplineScene
            scene="https://prod.spline.design/kZDDjO5HuC9GJUM2/scene.splinecode"
            className="w-full h-full"
          />
          {/* The Spline robot ships grey/blue from the CDN and can't be
              re-materialed from code, so we recolor it in the browser:
              `mix-blend-color` keeps the scene's luminance (its 3D shading +
              highlights) but replaces hue/saturation with pink. Dark areas keep
              luminance ~0, so the cherry card stays dark — only the robot pinks. */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 mix-blend-color"
            style={{
              background:
                'radial-gradient(circle at 60% 42%, #f9a8d0 0%, #ec4899 48%, #be185d 100%)',
            }}
          />
        </div>
      </div>
    </Card>
  );
}
